import { render, staticRenderFns } from "./DashboardSellerList.vue?vue&type=template&id=edb58c50&"
import script from "./DashboardSellerList.vue?vue&type=script&lang=js&"
export * from "./DashboardSellerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports